//@flow
import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Modal from '../../../../elements/Modal/Modal';
import {copyToClipboard} from '../../../../utils/clipboard';
import environment from '../../../../environment';

import copy from '../../../../assets/img/flight/copy.png';
import icons from '../../../../assets/styles/icons.scss';
import inputStyle from '../../../../assets/styles/input.scss';
import style from './FlightShare.scss';

import type {Flight, User} from '../../../../entities';

type Props = {
  flight: Flight;
  user: User;
  open: boolean;
  handleClose: () => void;
  handleOpen: () => void;
};

type State = {
  text: string;
};

export default class FlightShare extends Component<Props, State> {
  state = {
    text: '',
  };

  buildMessage = (url: string, user: User) => {
    const name =  user.firstName.toLowerCase().split(' ').join('');
    return `Trae tus compras de USA con ${name}. ${url}`;
  }

  buildPublicUrl = (flight: Flight, user: User) => {
    const baseUrl = environment.baseUrl['PE'];
    const name =  user.firstName.toLowerCase().split(' ').join('');
    return `${baseUrl}/public/flight/${flight.id}/${name}`;
  };

  handleClickFBSharedDialog = () => {
    const { flight, user } = this.props;
    const shareUrl = this.buildPublicUrl(flight, user);
    if (!(window: any).FB) return;
    (window: any).FB.ui({
      method: 'share',
      href: shareUrl,
    }, (response) => console.log(response));
  };

  handleClickTwitterShare = () => {
    const { flight, user } = this.props;
    const shareUrl = this.buildPublicUrl(flight, user);
    const message = this.buildMessage(shareUrl, user);
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}`;
    const width = 550;
    const height = 500;
    const options = `height=${height},width=${width},resizable=yes,toolbar=no,menubar=no,location=no,directories=no,status=yes`;
    window.open(url, 'popUpWindow', options);
  };

  handleCopyUrl = (urlRedirect: string) => {
    copyToClipboard(urlRedirect);
    // this.setState({ copyUrlClicked: true });
  };
  
  render() {
    const {flight, user, open, handleOpen, handleClose} = this.props;
    
    const url = this.buildPublicUrl(flight, user);
    
    return (
      <Fragment>
        <div className={style.shareWrap}>
          <button onClick={handleOpen}>
            <i className={icons.symbolShareDots}/>
            <span>Compartir viaje</span>
          </button>
          <div className={style.vl} />
          <a href={url}
             target="_blank">
            <i className={icons.symbolEye}/>
            <span>Ver mi viaje</span>
          </a>
        </div>
        <Modal handleClose={handleClose}
               open={open}
               showCloseButton={true}
               big>
          <div className={style.modalWrap}>
            <h3>Comparte tu viaje</h3>
            <div className={style.inputWrap}>
              <input type="text"
                     name="url"
                     className={classNames(inputStyle.input)}
                     readOnly
                     value={url} />
              <button className={style.copyButton}
                      onClick={() => this.handleCopyUrl(url)}>
                <img src={copy} alt="copy"/>
              </button>
            </div>
            <button className={classNames(style.shareButton, style.facebook)}
                     onClick={_ => this.handleClickFBSharedDialog()}>
              <i className={icons.symbolFacebook}/>
              <p>Compartir en Facebook</p>
            </button>
            <button className={classNames(style.shareButton, style.twitter)}
                     onClick={_ => this.handleClickTwitterShare()}>
              <i className={icons.symbolTwitter}/>
              <p>Compartir en Twitter</p>
            </button>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

FlightShare.propTypes = {
  flight: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleOpen: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/flight/components/FlightShare/FlightShare.jsx